import { DELIVERY_METHOD } from 'domains/seller-inbound/constants'
import TimeUtil from 'utils/time-util'
import * as Yup from 'yup'


/**
 * Create Consignment Inbound Request schema (all seller)
 *
 * ! We skip maximum quantity validation in the frontend (Backend still have the validation).
 *
 * It because we need to know the seller type in order to validate maximum quantity.
 * But in this case, Formik only save `seller id`.
 */
const consignmentInboundRequestCreateSchema = Yup.object().shape({
  seller       : Yup.number().required('Required'),
  quantity     : Yup.number().positive('Must be more than 0').required('Required'),
  scheduled_at : Yup.date()
    .min(TimeUtil.yesterday(), 'Must today or future date')
    .required('Required'),
  shipping_method: Yup.string().oneOf(
    Object.values(DELIVERY_METHOD),
    `Must be one of this value: ${Object.values(DELIVERY_METHOD).join(', ')}`
  ).required('Required'),
  pickup_address: Yup.object()
    .when('shipping_method', {
      is   : (value) => value === DELIVERY_METHOD.PICKUP,
      then : Yup.object().required('Required')
    }).nullable(),
  dropoff_location_city_id: Yup.number().when('shipping_method', {
    is   : (value) => value === DELIVERY_METHOD.DROPOFF,
    then : Yup.number().required('Required')
  })
})

export default consignmentInboundRequestCreateSchema
